import { gql } from '@apollo/client';

export const UPDATE_TEST_GROUP = gql`
  mutation updateTestGroup(
    $testGroupIdx: Int!
    $code: String
    $title: String
    $folderType: String
    $test_category_idx: Int
    $option_type: Int
  ) {
    updateTestGroup(
      testGroupIdx: $testGroupIdx
      code: $code
      title: $title
      folderType: $folderType
      test_category_idx: $test_category_idx
      option_type: $option_type
    ) {
      idx
      base_code
      test_category_idx
      option_type
      user {
        idx
        name
      }

      campus {
        idx
      }

      company {
        idx
      }
      name
      idate
      tests {
        idx
        code
        title
        meta
        type
        main_pdf {
          idx
        }
        extra_pdf {
          idx
        }
        extra_audio {
          idx
        }
        extra_video {
          idx
        }
        total_questions
        test_group {
          name
        }
        user {
          idx
          name
        }
      }
    }
  }
`;

export const UPDATE_TEST_SCORE = gql`
  mutation updateTestScore($testDetail: JSON) {
    updateTestScore(testDetail: $testDetail)
  }
`;
export const UPDATE_TEST_SCORE_BY_EXCEL = gql`
  mutation updateTestScoreByExcel($files: [Upload!], $test_idx: Int!) {
    updateTestScoreByExcel(files: $files, test_idx: $test_idx)
  }
`;
